import { useTranslation } from "react-i18next";
import { cn } from "../../lib/utils.js";
import { useInboxUnreadConversationCount } from "./InboxRealtimeProvider.js";

/** Compact numeric badge for the rail Inbox row (C-7c). Hidden when 0 / loading. */
export function InboxRailUnreadBadge({
  compact,
}: {
  compact: boolean;
}): React.JSX.Element | null {
  const { t } = useTranslation();
  const count = useInboxUnreadConversationCount();
  if (count == null || count <= 0) {
    return null;
  }

  const display = count > 99 ? "99+" : String(count);
  const aria = t("inbox.unreadSummary.aria", { count });

  return (
    <span
      className={cn(
        "grid place-items-center font-[700] tabular-nums",
        compact
          ? "absolute top-[5px] end-[7px] min-w-[17px] h-[17px] rounded-[9px] bg-nav-indicator px-1 text-[10px] font-[800] text-[#0b2524]"
          : "ms-auto min-w-[22px] h-[19px] rounded-[6px] bg-[rgba(108,225,180,0.16)] px-1.5 text-[11px] text-[#bfeedd]",
      )}
      aria-label={aria}
      data-testid="inbox-rail-unread-badge"
    >
      {display}
    </span>
  );
}
